/*!
|--------------------------------------------------------------------------
| Thinkidea Privacy Manager
|--------------------------------------------------------------------------
| Version : 1.0.0
|--------------------------------------------------------------------------
*/

(function () {

  'use strict';

  // 避免重複載入
  var loaded = false;
  var timer = null;

  function loadThirdPartyScripts() {

    var privacy = document.querySelector(
      '.avia-cookie-consent-wrap'
    );

    // 找不到 Cookie Banner，不執行
    if (!privacy) {
      return;
    }

    // 尚未同意分析／效能 Cookie（含 GTM），不執行
    // aria-hidden="true" 僅在 consent=all 或舊值 true 時由 base.js 設定
    if (privacy.getAttribute('aria-hidden') !== 'true') {
      return;
    }

    // 已經載入過，不重複執行
    if (loaded) {
      return;
    }

    loaded = true;

    /**************************************************************
     * Tracking Code 網站所有的第三方追蹤碼要放置在這
     **************************************************************/

    /* Google Tag Manager */
    const container_id = document.documentElement.lang !== 'en' ? 'GTM-K649K9X' : 'GTM-TKZTG3Q';
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',container_id);
    /*  End Google Tag Manager */

  }

  function checkPrivacy() {

    loadThirdPartyScripts();

    if (loaded && timer !== null) {
      clearInterval(timer);
      timer = null;
    }

  }

  // 立即檢查一次
  checkPrivacy();

  // 尚未同意時，每 5000 毫秒檢查一次
  if (!loaded) {
    timer = setInterval(checkPrivacy, 5000);
  }

})();
